export default function Welcome() {
  return (
    <section className="bg-white py-20 px-6">
      <div className="max-w-3xl mx-auto text-center">
        <p className="text-[#C8A97E] text-xs font-bold tracking-[0.4em] uppercase mb-4">
          OUR STORY
        </p>
        <h2
          className="text-[#2B5741] text-4xl font-bold mb-6"
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          Welcome
        </h2>
        <p className="text-gray-600 text-base leading-relaxed mb-8" style={{ fontFamily: 'Inter, sans-serif' }}>
          There's much to see here. We're Horn Property Maintenance and Construction — a Burlington-based team
          dedicated to delivering exceptional property care and construction services across Burlington and
          surrounding areas. From seasonal maintenance to full-scale renovations, we bring craftsmanship,
          reliability, and genuine care to every project. Take your time, look around, and drop us a line.
          We'd love to hear from you.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#services"
            className="bg-[#2B5741] text-white px-8 py-3 text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#3A7060] transition-colors whitespace-nowrap rounded-md"
          >
            FIND OUT MORE
          </a>
          <a
            href="tel:9058694676"
            className="flex items-center gap-2 border-2 border-[#2B5741] text-[#2B5741] px-8 py-3 text-xs font-bold uppercase tracking-[0.15em] hover:bg-[#2B5741] hover:text-white transition-colors whitespace-nowrap rounded-md"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill"></i>
            </div>
            Call us for a free quote
          </a>
        </div>
      </div>
    </section>
  );
}
